import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExactAlarmPermissionAdapter } from 'src/app/adapters/exact-alarm-permission/exact-alarm-permission.adapter';

@Injectable({
  providedIn: 'root'
})
export class ExactAlarmPermissionUseCase {
  constructor(
    private exactAlarmPermissionAdapter: ExactAlarmPermissionAdapter,
  ) {}

  requestPermission(): Observable<boolean> {
    const requestPermissionPromise = this.exactAlarmPermissionAdapter.requestPermission();
    return requestPermissionPromise;
  }

  hasPermission(): Observable<boolean> {
    const hasPermissionPromise = this.exactAlarmPermissionAdapter.hasPermission();
    return hasPermissionPromise;
  }
}
